<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card elevation-12 max-width="100%">
            <ChatHeader />
            <v-card-text>
                <v-container fluid>
                    <ChatBody />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <ChatWriter />
            </v-card-actions>
        </v-card>
        <div class="power-by-tu-botones">
            <a href="https://www.tubotones.com" target="_blank"> <p class="WhiteColor"> Bot ⚡️ by <span class="FontBold"> TuBotones </span> </p> </a>
        </div>
    </v-dialog>
</template>
<script>
import ChatHeader from './ChatHeader'
import ChatBody from './ChatBody'
import ChatWriter from './ChatWriter'
export default {
    components: {
        ChatHeader,
        ChatBody,
        ChatWriter
    },
    data: () => ({
        dialog: true
    }),
    mounted() {
        this.callAPI('init')
        // this.$store.dispatch('message/initChat', data)
    },
    methods: {
        callAPI(text, interactive = false, attachment = null) {
            let data = new FormData();
            const postData = {
                driver: "web",
                userId: this.userId,
                message: text,
                attachment,
                interactive,
                // attachment_data: document.getElementById("attachment").files[0]
            };
        Object.keys(postData).forEach(key => data.append(key, postData[key]));

        this.$store.dispatch('message/initChat', data)
    },
    }
}
</script>
<style>

    .power-by-tu-botones {
        text-align: center;
        padding-top: 10px;
    }
</style>